import { useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { SartellLogo } from "../../apps/availability/components/Logo";
import { HELP_SECTIONS } from "./content";

function Section({ section }) {
  // First item open by default — an accordion where everything is shut looks
  // like an empty page.
  const [open, setOpen] = useState(0);
  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800">{section.title}</h2>
      <p className="mt-1 text-gray-500">{section.intro}</p>
      <div className="mt-4 divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
        {section.items.map((item, i) => (
          <div key={item.q}>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              aria-expanded={open === i}
              className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left"
            >
              <span className="font-medium text-gray-800">{item.q}</span>
              <span className="shrink-0 text-gray-400">{open === i ? "–" : "+"}</span>
            </button>
            {open === i && (
              <div className="px-4 pb-4 space-y-2">
                {item.a.map((p, j) => (
                  <p key={j} className="text-sm leading-relaxed text-gray-600">
                    {p}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

/* One help page for the whole platform, at /help and /help/:section.
   Content is plain data in ./content.js so it versions with the code — no CMS,
   and adding an app's help is one more entry. */
export function HelpCenter() {
  const { section } = useParams();
  const active = section ? HELP_SECTIONS.find((s) => s.id === section) : null;
  if (section && !active) return <Navigate to="/help" replace />;
  const shown = active ? [active] : HELP_SECTIONS;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-white">
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex flex-col items-center text-center">
          <SartellLogo size="lg" subtitle={null} />
          <h1 className="mt-5 text-2xl font-bold text-gray-800">Help</h1>
        </div>

        {!active && (
          <nav className="mt-6 flex flex-wrap justify-center gap-2">
            {HELP_SECTIONS.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm
                           font-medium text-gray-600 hover:border-blue-300 hover:text-blue-700"
              >
                {s.title}
              </a>
            ))}
          </nav>
        )}

        <div className="mt-8 space-y-10">
          {shown.map((s) => (
            <div key={s.id} id={s.id} className="scroll-mt-6">
              <Section section={s} />
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-xl border border-slate-200 bg-white p-4 text-center">
          <p className="text-sm text-gray-600">
            Still stuck? Email the club and someone will help.
          </p>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-sm font-semibold text-blue-600 hover:text-blue-800">
            ← Back to Sartell Soccer Apps
          </Link>
        </div>
      </div>
    </div>
  );
}
